import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b181391"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-11/12 h-65 box-shadow m-4 flex p-4",
  style: {"border-radius":"6px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-6/12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "max-w-full max-h-full",
    src: "https://www.zobec.si/wp-content/uploads/FORMA-slike-OranznoRjava-1-570x435.jpg"
  })
], -1))
const _hoisted_3 = { class: "w-6/12 h-max grid text-center" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = {
  class: "my-2",
  style: {"color":"#707070"}
}
const _hoisted_6 = { class: "place-content-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-round align-middle text-lg leading-none" }, "check", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_more_info_button = _resolveComponent("more-info-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.itemData.title), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.itemData.price), 1),
        _createVNode(_component_more_info_button, {
          title: _ctx.$t('Več info'),
          item: _ctx.itemData
        }, null, 8, ["title", "item"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_a_input, {
          class: "my-4 hideStepper",
          style: {"height":"40px","border-radius":"6px","width":"60%"},
          type: "number",
          placeholder: _ctx.$t('Vpiši kvadraturo'),
          suffix: "m2"
        }, null, 8, ["placeholder"]),
        _createElementVNode("div", null, [
          (_ctx.itemAdded==true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "w-full app-button-addon-selected",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addItem(false)))
              }, [
                _hoisted_7,
                _createTextVNode("  " + _toDisplayString(_ctx.$t("Dodano")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.itemAdded==false)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "w-full app-button-addon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addItem(true)))
              }, _toDisplayString(_ctx.$t("Dodaj")), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}